import React, { useEffect, useRef } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import SimpleBox from "../layout/container/SimpleBox";
import TextInput from "../input/text/TextInput";
import TextArea from "../input/text/TextArea";
import EmailInput from "../input/text/EmailInput";
import SubmitButton from "../input/button/SendButton";

import { apiPublicContact } from "../../api/public";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";

// `defaultTopic` prefills the free-text "Assunto" field (e.g. a caller on a
// members-only page might want to default it to "Sócios") — it's no longer
// one of a fixed set of options tied to routing the email to a specific
// mailbox; every submission always goes through the same club inbox now
// (see adcb-backend's `send_adcb_contact_email`), so the visitor's own
// wording is what actually identifies the topic for whoever reads it.
const ContactForm = ({ fixedName = null, fixedEmail = null, fixedPhone = null, defaultTopic = null }) => {

    const recaptchaRef = useRef(null);
    const recaptchaKey = "6LdoA_gpAAAAACn8foSkx8VqrEh5C05uIpZc_B8b";

    const [name, setName] = React.useState(fixedName);
    const [email, setEmail] = React.useState(fixedEmail);
    const [phone, setPhone] = React.useState(fixedPhone);
    const [subject, setSubject] = React.useState(defaultTopic ?? "");
    const [message, setMessage] = React.useState(null);
    const [recaptcha, setRecaptcha] = React.useState(null);

    useEffect(() => {
        setName(fixedName);
        setEmail(fixedEmail);
        setPhone(fixedPhone);
    }, [fixedName, fixedEmail, fixedPhone]);

    const handleSubmit = (event) => {
        event.preventDefault();
        apiPublicContact({ name, email, phone, subject, message, recaptcha }, (data, successFlag) => {
            if (successFlag) {
                setName(null);
                setEmail(null);
                setPhone(null);
                setSubject("");
                setMessage(null);
                setRecaptcha(null);
                recaptchaRef.current.reset();
                toast.success("Mensagem enviada com sucesso");
            }
        });
    }

    const submitDisabled = !Boolean(recaptcha);

    return (
        <form onSubmit={handleSubmit}>
            <SimpleBox flexDirection="column" gap={4} fullWidth={true}>
                <TextInput id="name" label="Nome" value={name} onChange={(event) => setName(event.target.value)} />
                <SimpleBox gap={4} fullWidth={true}>
                    <EmailInput id="email" label="Email" value={email} onChange={(event) => setEmail(event.target.value)} />
                    <TextInput id="phone" label="Telefone" value={phone} onChange={(event) => setPhone(event.target.value)} />
                </SimpleBox>
                <TextInput id="subject" label="Assunto" value={subject} onChange={(event) => setSubject(event.target.value)} />
                <TextArea id="message" label="Mensagem" value={message} onChange={(event) => setMessage(event.target.value)} />
                <ReCAPTCHA ref={recaptchaRef} sitekey={recaptchaKey} onChange={setRecaptcha} onExpired={() => setRecaptcha(null)} />
                <SimpleBox fullWidth={true} justifyContent="center">
                    <SubmitButton disabled={submitDisabled} />
                </SimpleBox>
            </SimpleBox>
        </form>
    );
}

export default ContactForm;
